import { FC } from "react"
import { Drawer } from "antd"
import {
  XMarkIcon
} from "@heroicons/react/24/outline"
import { productName, sportNoun } from "./sportConfig"

type TermsDrawerProps = {
  isOpen: boolean
  onClose?: () => void
}
export const TermsDrawer: FC<TermsDrawerProps> = ({ isOpen, onClose }) => {
  return (
    <Drawer
      open={isOpen}
      title={'General Terms and Conditions (GTC)'}
      closeIcon={
        <div style={{ width: '30px' }}>
          <XMarkIcon style={{ color: '#fff', height: '30px', width: '30px' }} fontSize={30} />
        </div>
      }
      size={'large'}
      onClose={() => onClose?.()}
      headerStyle={{
        background: '#000',
        color: '#fff',
        fontFamily: '"Space Grotesk", sans-serif'
      }}
      styles={{
        body: {
          background: '#000',
          fontFamily: '"Space Grotesk", sans-serif',
          color: '#fff'
        }
      }}
    >
      <div>
        
        <h3 dir="ltr">
          1. Introduction
        </h3>
        <p dir="ltr">
          These GTC govern the use of the {productName} application, a digital
          tactical board designed for {sportNoun}, operated by NYBE PLAY Limited
          Liability Company (registered office: Hungary, 1183 Budapest, Alpár Street
          24; tax number: 32713172-2-43, company registration number: 01-09-438732,
          hereinafter: Service Provider). Downloading and using the application
          constitutes acceptance of these GTC.
        </p>
        
        <h3 dir="ltr">
          2. Services
        </h3>
        <p dir="ltr">
          The application and its services are accessible at
          <a href="https://www.thewaterpoloplaybook.com/">
            https://www.thewaterpoloplaybook.com
          </a>
          .
        </p>
        
        <p dir="ltr">
          The application is an innovative digital tactical board specifically created
          for {sportNoun} coaches and players. Users can download the app for a
          one-time fee, which offers two subscription options: the Basic Version,
          which provides core functionalities, and the Pro Plan, which offers extended
          features for tactical planning and more efficient training management. The
          aim of the application is to facilitate the development and visual
          presentation of {sportNoun} strategies.
        </p>
        
        <h3 dir="ltr">
          3. Subscription and Fees
        </h3>
        <p dir="ltr">
          The user pays a one-time fee for downloading the application, payable at the
          moment of download.
        </p>
        
        <p dir="ltr">
          Basic Version: Core functions enabling {sportNoun} tactical planning.
          Available upon application download and purchase.
        </p>
        
        <p dir="ltr">
          Pro Plan: Additional, extended features offering extra options to users.
          Accessed through a subscription.
        </p>
        
        <p dir="ltr">
          Subscriptions automatically renew according to the chosen period unless the
          user cancels the subscription.
        </p>
        
        <p dir="ltr">
          The Pro Plan is available on a monthly or annual subscription basis at a
          higher fee. The Service Provider reserves the right to offer discounted
          prices to users opting for annual subscriptions.
        </p>
        <p dir="ltr">
          The Service Provider reserves the right to set and modify the download and
          subscription fees at its sole discretion. Current fees are always published
          on the website.
        </p>
        <p dir="ltr">
          Payment for subscriptions is processed through the online payment service
          provided by Stripe Inc. The subscriber acknowledges that payment
          transactions occur via Stripe’s secure platform, and the terms and privacy
          policies of Stripe apply. By providing payment information, the subscriber
          consents to its transfer to Stripe for payment processing. The subscriber
          understands that the Service Provider does not handle or store bank card
          data. Additionally, the subscriber agrees that subscription fees are
          automatically deducted by Stripe according to the subscription period.
        </p>
        <p dir="ltr">
          Trial Period:
        </p>
        <p dir="ltr">
          For Pro Plan subscriptions, the Service Provider offers a 14-day free trial.
          During this trial, the subscriber may cancel the subscription at any time.
          After the trial period, the bank card registered for the subscription will
          be charged automatically. The Service Provider will notify subscribers of
          the end of the trial via email.
        </p>
        <p dir="ltr">
          Cancellation Policy:
        </p>
        <p dir="ltr">
          Subscribers can cancel their subscription through the application interface.
          During the paid period, subscribers are entitled to use the application.
        </p>
        <p dir="ltr">
          Application Restriction:
        </p>
        <p dir="ltr">
          If a subscription fee cannot be charged due to insufficient funds, the
          Service Provider will restrict access to the Pro Plan features after 3 days
          from the failed transaction. Subsequently, the subscriber must manually
          update their bank card details via the subscription interface. Upon
          successful charge, full access to the Pro Plan features is restored.
        </p>
        <h3 dir="ltr">
          4. Liability
        </h3>
        <p dir="ltr">
          The Service Provider is not responsible for issues arising from improper use
          of the application or unintended subscriptions. Users are advised to
          carefully read and properly manage their settings.
        </p>
        <p dir="ltr">
          The Service Provider reserves the right to restrict the use of the
          application in case of unlawful use by the user or subscriber.
        </p>
        
        <h3 dir="ltr">
          5. Data Protection
        </h3>
        
        <p dir="ltr">
          Protecting user data is of utmost importance. Details regarding data
          management are included in the separate Privacy Policy.
        </p>
        
        <h3 dir="ltr">
          6. Copyright and Intellectual Property Rights
        </h3>
        
        <p dir="ltr">
          The application, as a work of intellectual property, is owned by NYBE PLAY
          Limited Liability Company, i.e., the Service Provider. All rights are
          reserved, including copyrights, trademarks, and other intellectual property
          rights. Users are only authorized to use the service for its intended
          purpose. Copying, distributing, modifying, or otherwise using the
          application or its content without prior written consent from the Service
          Provider is prohibited. Violations of intellectual property rights may
          result in legal consequences, and the Service Provider reserves the right to
          take legal action to protect its rights.
        </p>
        
        
        <h3 dir="ltr">
          7. Final Provisions
        </h3>
        <p dir="ltr">
          These GTC may be modified at any time. Users will be notified of changes
          upon their next login. Continued use of the service constitutes acceptance
          of the modified terms.
        </p>
        
      </div>
    </Drawer>
  )
}